<script lang="ts">
  import RoundImage from "@shared/svelte/Components/RoundImage.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { RoundImageContainerEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";
  export let forwardStateName: string;
  export let forwardStateParams: any;
  export let imageUrl: string;
  export let imageAltText: string | null = null;
  export let text: string;

  const { trackMrcEvents } = EventTracking;

  const roundImageContainer = new RoundImageContainerEntity({
    forward_state_name: forwardStateName,
    forward_state_params: forwardStateParams,
    image_asset_url: imageUrl,
    text: text,
  });
</script>

<TrackingContext entities={roundImageContainer} let:trackingContext>
  <div
    class="fizz-styles"
    data-testid="round-image-container"
    use:trackMrcEvents={[trackingContext.entities]}
  >
    <UIRouterLink
      classes={"fizz-text-inherit"}
      params={forwardStateParams}
      stateName={forwardStateName}
      useTrackClick={true}
    >
      <RoundImage {imageUrl} {imageAltText} {text} />
    </UIRouterLink>
  </div>
</TrackingContext>
